const getPrefixId = (prefix, prefixObject) => {
  if (!prefix) return null;
  if (typeof prefix === 'number') return prefix;

  const matchedPrefix = prefixObject?.find(item => item.PrefixDescription === prefix || item.PrefixCode === prefix);

  return matchedPrefix?.PrefixId || null;
};

const updateProfilePayload = (values, prefixObject) => {
  const payload = {
    PersonId: values.PersonId,
    firstName: values.Name.First,
    middleName: values.Middle ? values.Middle : '',
    lastName: values.Name.Last,
    prefixId: getPrefixId(values.Prefix, prefixObject),
    suffixName: values.Suffix ? values.Suffix : '',
    informalSalutation: values.Informal ? values.Informal : '',
    titleDescription: values.Title,
    company: values.Company,
    countryCode: values.CountryCode,
    country: values.Country ? values.Country : '',
    streetAddress: values.StreetAddress1,
    suite: values.StreetAddress2 ? values.StreetAddress2 : '',
    city: values.City,
    stateCode: values.StateCode,
    postalCode: values.PostalCode,
    workPhone: values.Phone.Number,
    extension: values.Extension ? values.Extension : '',
    cellPhone: values.Mobile ? values.Mobile : '',
    emailAddress: values.EmailAddress,
    confirmEmailAddress: values.ConfirmEmailAddress,
    comments: values.Comments,
  };

  return payload;
};

export default updateProfilePayload;